import React from 'react';
import { ArrowRight, ArrowLeft } from '@phosphor-icons/react';
import Form from 'components/Form/Form/index';
import SelectInput from 'components/Form/SelectInput/index';

export default function Pagination({
    next,
    prev,
    component,
    page,
    limits,
    onLimitChange,
}) {

    const Component = component || 'div';

    return (
        <div className='flex justify-between items-center w-full'>
            <div></div>
            <div className='flex justify-center items-center'>
                {prev &&
                    <Component href={prev} to={prev} className='border border-line py-2 px-4 rounded-lg flex items-center hover:bg-light mx-1'>
                        <ArrowLeft className='mr-2 h-5 w-5' />
                        Precedente
                    </Component>
                }

                {page &&
                    <div className="hidden md:flex border border-line rounded-lg py-2 px-4 items-center justify-center mx-1">{page}</div>
                }

                {next &&
                    <Component href={next} to={next} className='border border-line py-2 px-4 rounded-lg flex items-center hover:bg-light mx-1'>
                        Successivo
                        <ArrowRight className='ml-2 h-5 w-5' />
                    </Component>
                }
            </div>
            <div>
                {limits && onLimitChange &&
                    <Form>
                        <SelectInput
                            name="limit"
                            label="Limite"
                            placeholder="Limite"
                            options={limits?.map((limit) => ({
                                label: limit,
                                value: limit
                            }))}
                            onChange={onLimitChange}
                            isSearchable={false}
                            isClearable={false}
                            isMulti={false}
                            isLoading={false}
                        />
                    </Form>
                }
            </div>
        </div>
    )
}